export const MOBILE_VIEWPORT_MEDIA =
	"@media (max-width: 768px), (max-width: 1000px) and (max-height: 500px)"

export const isMobileViewport = (width: number, height: number) =>
	width <= 768 || (width <= 1000 && height <= 500)
